<ng-template #root>
  <div
    class="z-50 mt-xs w-full overflow-y-auto rounded-3 border border-grey-200 bg-white shadow-1"
    data-testid="dropdown"
    tabindex="-1"
  >
    <ng-container *ngTemplateOutlet="content.tpl"></ng-container>
  </div>
</ng-template>
